import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { SelectedNodesProvider } from '@/features/connect-dots/contexts/SelectedNodesProvider';
import { TagViewContainer } from '@/features/connect-dots/components/containers/TagViewContainer';
import { FilterMirrorContainer } from '@/features/connect-dots/components/containers/FilterMirrorContainer';

export const TagViewDialog = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  const title = t('RuleWatcherタグを探索し、選択する');

  // サイドバー
  const sidebarContent = <FilterMirrorContainer onClose={onClose} />;

  // メインコンテンツ
  const mainContent = <TagViewContainer />;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* グレーの半透明オーバーレイ */}
      <div className="fixed inset-0 bg-black/20" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <SelectedNodesProvider>
          <DialogPanel className="relative m-8 size-full overflow-y-hidden rounded-lg bg-white shadow-lg">
            {/* ヘッダー */}
            <div className="flex justify-between border-b p-1">
              <DialogTitle className="pl-2 text-xl font-semibold">
                {title}
              </DialogTitle>
              {/* 閉じるボタン */}
              <button
                onClick={onClose}
                className="m-2 rounded border border-rw-light-gray px-2 py-1 text-sm text-black hover:opacity-80"
              >
                {t('もどる')}
              </button>
            </div>

            {/* メインコンテンツエリア */}
            <div className="flex size-full">
              {/* サイドバー */}
              <div className="h-full shrink-0 border-r bg-gray-200">
                {sidebarContent}
              </div>

              {/* メインコンテンツ */}
              <div className="w-full flex-1 p-1">{mainContent}</div>
            </div>
          </DialogPanel>
        </SelectedNodesProvider>
      </div>
    </Dialog>
  );
};
